import { EditorUtils } from '../../util/editor-utils.js';
import 'vue';
import '@ssml-editor/core';
import '../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import '../../_virtual/lodash.js';

const withMaxLength = (editor, maxLength) => {
  const newEditor = editor;
  newEditor.getLength = () => {
    if (editor.children.length > 0) {
      return EditorUtils.getLength(editor, []);
    } else {
      return 0;
    }
  };
  newEditor.getLeftLength = () => {
    if (maxLength && maxLength > 0) {
      return maxLength - newEditor.getLength();
    } else {
      return Infinity;
    }
  };
  return newEditor;
};

export { withMaxLength };
//# sourceMappingURL=with-max-length.js.map
